import * as React from 'react';
const SvgPeople = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.6 11.2h7.2a1.6 1.6 0 0 1 1.596 1.48l.004.12V14c0 2.8-2.973 3.6-5.2 3.6-2.178 0-5.068-.764-5.196-3.416L2 14v-1.2a1.6 1.6 0 0 1 1.48-1.596zm8.976 0H16.4a1.6 1.6 0 0 1 1.596 1.481l.004.12v.8c0 2.449-2.286 3.2-4 3.2a5.7 5.7 0 0 1-1.712-.258c.269-.309.486-.662.642-1.062.434.1.842.12 1.07.12l.213-.005c.788-.035 2.47-.291 2.581-1.832l.006-.164v-.8a.4.4 0 0 0-.328-.393L16.4 12.4h-3.24a2.37 2.37 0 0 0-.476-1.072zH16.4zM3.6 12.4l-.08.008a.4.4 0 0 0-.203.108.4.4 0 0 0-.109.203l-.008.08V14c0 .808.36 1.378 1.134 1.794.66.356 1.602.571 2.612.602l.254.004.254-.003c1.01-.032 1.95-.247 2.612-.603.725-.39 1.087-.916 1.13-1.646L11.2 14v-1.2a.4.4 0 0 0-.328-.393L10.8 12.4zm3.6-10a3.6 3.6 0 1 1 0 7.201 3.6 3.6 0 0 1 0-7.2M14.4 4a2.8 2.8 0 1 1 0 5.6 2.8 2.8 0 0 1 0-5.6m-7.2-.4A2.403 2.403 0 0 0 4.8 6c0 1.324 1.077 2.4 2.4 2.4S9.6 7.324 9.6 6 8.523 3.6 7.2 3.6m7.2 1.6c-.882 0-1.6.718-1.6 1.6s.718 1.6 1.6 1.6S16 7.683 16 6.8c0-.882-.718-1.6-1.6-1.6"
    />
  </svg>
);
export default SvgPeople;
